import './index.less';

import icon from './sharp-clear-24px.svg';

const TagPill = ({ label, index, onClick }) => <div className="tagpill">
  <em>{label}</em>
  <button
    type="button"
    onClick={() => onClick({ label, index })}
  ><img src={icon} alt="Remove tag"/></button>
</div>;

export default TagPill;
